import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {ContactDTO} from '../model/contactDTO';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  private readonly path = environment.baseUrl + environment.apiPrefix + 'contact';

  constructor(private http: HttpClient) {
  }

  contact(contact: ContactDTO) {
    return this.http.post<void>(this.path, contact);
  }
}
